import NumeroObjetCode from '@/generated/controls/numeroObjet/NumeroObjetCode.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: NumeroObjetCode
})
